module.exports = __webpack_public_path__ + "static/message-background-pc-d67ec025ddd855485b01aa52b03f0f14.jpg";